import React from 'react';
import './style.scss';
import Header from "../../Header";
import goBack from "../../../assets/img/header/go__back.svg";
import {useHistory} from "react-router-dom";

const PopularMixesHeader = () => {
    const history = useHistory();
    return (
        <Header>
            <div className="popular-mixes__header-container">
                <img
                    className="popular-mixes__header-img"
                    onClick={() => history.goBack()}
                    src={goBack}
                    alt="Go Back"
                />
                <div className="popular-mixes__header-text">
                    <span className="header__standard-text">
                        Популярные миксы
                    </span>
                </div>
            </div>
        </Header>
    )
};

export default PopularMixesHeader;
